import timg1 from '../images/team/team_member_image_1.d0dbf19be5a0aca60fab.webp'
import timg2 from '../images/team/team_member_image_4.56f63fac139219ac4730.webp'
import timg3 from '../images/team/team_member_image_5.b3f66d9ea9e325f352e3.webp'
import timg4 from '../images/team/team_member_image_1.d0dbf19be5a0aca60fab.webp'
import timg5 from '../images/team/team_member_image_5.b3f66d9ea9e325f352e3.webp'


const Teams = [
   {
      Id: '1',
      tImg: timg1,
      name: 'Atticus Sterling',
      slug: 'Atticus-Sterling',
      title: 'Systems Engineer',
   },
   {
      Id: '2',
      tImg: timg2,
      name: 'Orion Jasper',
      slug: 'Orion-Jasper',
      title: 'IT Consultant',
   },
   {
      Id: '3',
      tImg: timg3,
      name: 'August Everest',
      slug: 'August-Everest',
      title: 'systems engineer',
   },
   {
      Id: '4',
      tImg: timg4,
      name: 'Maverick Phoenix',
      slug: 'Maverick-Phoenix',
      title: 'data analyst',
   },
   {
      Id: '5',
      tImg: timg5,
      name: 'Daxton Atlas',
      slug: 'Daxton-Atlas',
      title: 'Project Manager',
   },
   {
      Id: '6',
      tImg: timg4,
      name: 'Maverick Phoenix',
      slug: 'Maverick-Phoenix',
      title: 'data analyst',
   },
   
]

export default Teams;